import { stats } from "@/mocks/nanaData";

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20abstract%20flat%20illustration%20of%20floating%20chat%20bubbles%20and%20sparkles%2C%20coral%20red%2C%20amber%20gold%20and%20cream%20palette%2C%20modern%20minimal%20vector%20art%2C%20soft%20gentle%20gradients%2C%20energetic%20community%20discussion%20atmosphere&width=1600&height=1000&seq=hero-bg&orientation=landscape"
          alt="娜娜51热评圈 - 网络热议话题聚合背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/45 to-foreground-950/70"></div>
      </div>

      <div className="relative mx-auto flex min-h-[600px] max-w-7xl w-full flex-col items-center justify-center px-4 py-28 text-center md:px-6 md:py-32">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs text-background-50 backdrop-blur">
          <i className="ri-fire-line"></i>
          贴吧 · 知乎 · 论坛 · 热搜 四方热议实时汇总
        </span>
        <h2 className="max-w-4xl font-[ZCOOL_KuaiLe] text-4xl leading-tight text-background-50 md:text-6xl">
          娜娜51 热议风向标
          <span className="block text-accent-300">吃瓜看戏，不迷路</span>
        </h2>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          每天帮你把散落在各大平台的「娜娜51」相关热帖、高赞回答与热搜动态集中梳理，围观网友观点交锋，也看门道。理性吃瓜，友好讨论。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <button
            onClick={() => document.querySelector("#hot")?.scrollIntoView({ behavior: "smooth" })}
            className="inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            看看今日热搜 <i className="ri-arrow-right-line ml-1"></i>
          </button>
          <button
            onClick={() => document.querySelector("#topics")?.scrollIntoView({ behavior: "smooth" })}
            className="inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-full bg-background-50/15 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/25"
          >
            逛逛热议话题
          </button>
        </div>

        <div className="mt-12 grid w-full grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-2xl bg-background-50/10 px-4 py-4 text-center backdrop-blur">
              <p className="font-[ZCOOL_KuaiLe] text-2xl text-accent-300 md:text-3xl">{s.value}</p>
              <p className="mt-1 text-xs text-background-100 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}